import { useQuery } from '@tanstack/react-query';
import { fetchProductivitySummary } from '@apis/productivity';

/**
 * Fetches the always-visible Productivity summary cards (metrics, insight,
 * exceptions) for a site. The summary is a current snapshot, so it
 * fires once a site is present. staleTime 5 min — the all-time figures don't
 * change within a normal session.
 */
export function useProductivitySummary(siteId: string | undefined) {
  return useQuery({
    queryKey: ['productivity', 'summary', siteId],
    queryFn: ({ signal }) => fetchProductivitySummary(siteId!, signal),
    enabled: !!siteId,
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: false,
  });
}
